@use "../../../../globals/settings";
@use "../../../../globals/bcp";
@use "../../../../globals/libs/hy.core.css/layout/page-row";

:host {
  box-sizing: border-box;
  display: flex;
}

.o-header__search {
  .m-search-form {
    transition: none;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    display: none;
  }

  &.is-open {
    .m-search-form {
      @include bcp.z-index("search", 1);
      display: block;
      opacity: 1;
    }
  }
}

.m-search-form__inner {
  @include page-row.page-row;

  @include bcp.respond-lte(tabletp) {
    padding-left: 0;
    padding-right: 0;
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
